import { render, staticRenderFns } from "./VehicleManageDetail.vue?vue&type=template&id=25afba06&scoped=true"
import script from "./VehicleManageDetail.vue?vue&type=script&lang=js"
export * from "./VehicleManageDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleManageDetail.vue?vue&type=style&index=0&id=25afba06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25afba06",
  null
  
)

export default component.exports